if (window.location.href.indexOf("jsName=BimEx") !== -1) {
  window.name = "BimEx";
} else {
  window.name = "";
}
// 判断是否是rvt端
if (window.location.href.indexOf("jsName=BimExRVT") !== -1) {
  window.name = "BimExRVT";
} else {
  window.name = "";
}
import { storage } from "@/CommonDP/utils";
const app = {
  state: {
    sidebar: {
      opened: storage.get("sidebarStatus") ? !!+storage.get("sidebarStatus") : true,
      withoutAnimation: false
    },
    showBar: window.name !== "BimEx",
    isRVT: window.name !== "BimExRVT",
    device: "desktop",
    language: storage.get("language") || "en",
    size: storage.get("size") || "medium",
    isWebView: false, // 是否为app的webview调用
  },
  mutations: {
    TOGGLE_SIDEBAR: state => {
      state.sidebar.opened = !state.sidebar.opened;
      state.sidebar.withoutAnimation = false;
      if (state.sidebar.opened) {
        storage.set("sidebarStatus", 1);
      } else {
        storage.set("sidebarStatus", 0);
      }
    },
    CLOSE_SIDEBAR: (state, withoutAnimation) => {
      storage.set("sidebarStatus", 0);
      state.sidebar.opened = false;
      state.sidebar.withoutAnimation = withoutAnimation;
    },
    TOGGLE_DEVICE: (state, device) => {
      state.device = device;
    },
    SET_LANGUAGE: (state, language) => {
      state.language = language;
      storage.set("language", language);
    },
    SET_SIZE: (state, size) => {
      state.size = size;
      storage.set("size", size);
    },
    SET_WEBVIEW: (state, isWebView) => {
      state.isWebView = isWebView;
    },
  },
  actions: {
    toggleSideBar({ commit }) {
      commit("TOGGLE_SIDEBAR");
    },
    closeSideBar({ commit }, { withoutAnimation }) {
      commit("CLOSE_SIDEBAR", withoutAnimation);
    },
    toggleDevice({ commit }, device) {
      commit("TOGGLE_DEVICE", device);
    },
    setLanguage({ commit }, language) {
      commit("SET_LANGUAGE", language);
    },
    setSize({ commit }, size) {
      commit("SET_SIZE", size);
    },
    setWebView({ commit }, isWebView) {
      commit("SET_WEBVIEW", isWebView);
    },
  }
};

export default app;
